module.exports = __webpack_public_path__ + "img/report.f785719.svg";